import { render, staticRenderFns } from "./UserSignature.vue?vue&type=template&id=286df3cc&"
import script from "./UserSignature.vue?vue&type=script&lang=js&"
export * from "./UserSignature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('286df3cc')) {
      api.createRecord('286df3cc', component.options)
    } else {
      api.reload('286df3cc', component.options)
    }
    module.hot.accept("./UserSignature.vue?vue&type=template&id=286df3cc&", function () {
      api.rerender('286df3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/components/UserSignature.vue"
export default component.exports